export function setEmergencies(state, emergencies) {
    state.emergencies = emergencies;
}

export function setEmergency(state, emergency) {
    state.emergency = emergency;
}

